/** Shared display formatters (money, dates, numeric parsing). */

export function parseMoney(v: unknown): number {
  if (v == null) return 0;
  const n = parseFloat(String(v).replace(/[^0-9.]/g, ''));
  return Number.isNaN(n) ? 0 : n;
}

export function money(v: unknown): string {
  const n = typeof v === 'number' ? v : parseMoney(v);
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
}

export function fmtDate(v: unknown): string {
  if (!v) return '';
  const d = new Date(String(v));
  return Number.isNaN(d.getTime())
    ? String(v)
    : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

// ---- Live input formatters (format-as-you-type) ----

/** Format a currency input as $ with thousands separators, e.g. "$8,500". */
export function currencyInput(v: string): string {
  const digits = v.replace(/[^0-9]/g, '');
  if (!digits) return '';
  return '$' + Number(digits).toLocaleString('en-US');
}

/** Format a phone input as "123-456-7890". */
export function phoneInput(v: string): string {
  const d = v.replace(/\D/g, '').slice(0, 10);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
}
